import { useEffect, useState } from "react";
import { api } from "../lib/api";

const usd = (v) => (v == null ? null : `$${v.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`);

const Chip = ({ sym, color, amt, unit, value, testid, onClick }) => {
  const Tag = onClick ? "button" : "div";
  return (
  <Tag type={onClick ? "button" : undefined} onClick={onClick} data-testid={testid}
    className={`flex items-center gap-1.5 whitespace-nowrap rounded-sm border border-[var(--r2-border)] px-2 py-0.5 font-mono tabular-nums transition-colors ${onClick ? "hover:border-[var(--r2-text2)]" : ""}`}>
    <span className="font-bold" style={{ color }}>{sym}</span>
    <span className={amt == null ? "text-[var(--r2-text2)]" : "text-[var(--r2-text1)] font-bold"}>{amt == null ? "…" : `${amt.toFixed(4)} ${unit}`}</span>
    {value != null && <span className="text-[var(--r2-text2)]">≈ {usd(value)}</span>}
  </Tag>
  );
};

/* Both live wallets (Solana + Robinhood Chain) with USD value — shown at the top of the meme and RH Chain dashboards. */
export const WalletBalances = ({ onSolClick, onEthClick }) => {
  const [sol, setSol] = useState(null);
  const [eth, setEth] = useState(null);
  useEffect(() => {
    const load = () => {
      api.meme.wallet().then(setSol).catch(() => {});
      api.rhchain.status().then((s) => setEth({ bal: s?.stats?.eth_balance, usd: s?.eth_usd })).catch(() => {});
    };
    load();
    const id = setInterval(load, 15000);
    return () => clearInterval(id);
  }, []);
  const solAmt = sol?.balances?.sol ?? null;
  const solUsd = solAmt != null && sol?.sol_usd ? solAmt * sol.sol_usd : null;
  const ethAmt = eth?.bal ?? null;
  const ethUsd = ethAmt != null && eth?.usd ? ethAmt * eth.usd : null;
  const total = solUsd != null || ethUsd != null ? (solUsd || 0) + (ethUsd || 0) : null;
  return (
    <div className="flex items-center gap-2 text-[9px]" data-testid="wallet-balances">
      <Chip sym="◎" color="#CCFF00" amt={solAmt} unit="SOL" value={solUsd} testid="wallet-balance-sol" onClick={onSolClick} />
      <Chip sym="Ξ" color="#00C805" amt={ethAmt} unit="ETH" value={ethUsd} testid="wallet-balance-eth" onClick={onEthClick} />
      <span className="whitespace-nowrap font-mono tabular-nums text-[var(--r2-text2)]" data-testid="wallet-balance-total">TOTAL <span className="text-[var(--r2-text1)] font-bold">{total == null ? "…" : usd(total)}</span></span>
    </div>
  );
};
